import { useState, useEffect } from 'react';

export default function useInitSearchInput(entityType: string) {
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    setFlag(true);

    setTimeout(() => {
      setFlag(false);
    });
  }, [entityType]);

  return flag;
}
